import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box, Checkbox, FormControlLabel, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import { Line } from 'react-chartjs-2'
import { Input } from 'Components/Input'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function TauxImposition({ updateReports, setTauxImOpen }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  const [taxrates, setTaxrates] = useState([])
  const [labels, setLabels] = useState([])
  const [ldata, setLdata] = useState([])
  const [open, setOpen] = useState(true)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    fetchTaxRates()
  }, [])

  // const handleClickOpen = () => {
  //   setOpen(true)
  // }

  const handleClose = () => {
    setOpen(false)

    setTauxImOpen(false)
    updateReports()
  }

  const fetchTaxRates = async () => {
    const url = urls.TaxRateOperations
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let labels = []
      let ldata = []
      data?.results.forEach((el) => {
        labels.push(convertToUserDateFormate(siteUser.user, el.Date))
        ldata.push(parseInt(el.Taux).toFixed(0))
      })
      setLabels(labels)
      setLdata(ldata)
      setTaxrates(data?.results)
    }
  }

  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: ldata,
        borderColor: '#0dcaf0',
        backgroundColor: '#0dcaf0',
      },
    ],
  }

  const options = {
    maintainAspectRatio: false,

    responsive: true,
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return [value] + ' %'
        },

        color: 'black',
        anchor: 'start',
        align: 'right',
      },
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: true,
        text: t('monPatrimoine.tauxEvolution'),
      },
    },
    scales: {
      x: {
        offset: false,
        ticks: {
          padding: 5,
        },
      },
      y: {
        ticks: {
          callback: (val) => {
            return val + '%'
          },
        },
        max: Math.max(...ldata) + 1,
      },
    },
  }

  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert(t('monPatrimoine.selectOperationsAlert'))
    } else {
      const response = await makePostRequest(
        urls.DeleteBulkTaxRate,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchTaxRates()
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose} className="no-drag">
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 0, right: 0 }}
          aria-label="fingerprint"
          color="secondary"
        >
          <CloseIcon sx={{ color: 'black' }} />
        </IconButton>
        <DialogTitle sx={{ color: '#383838 !important' }}>{t('monPatrimoine.tauxImpositionTitle')}</DialogTitle>

        <DialogContent>
          <Box
            display={'flex'}
            height={'70vh'}
            borderTop={'1px solid #74b7fd'}
            borderBottom={'1px solid #74b7fd'}
          >
            <Box width={'35%'} overflow={'auto'} borderRight={'1px solid #74b7fd'}>
              <Box display={'flex'} justifyContent={'flex-end'}>
                <AddTaux updateReports={fetchTaxRates} />

                <IconButton onClick={deleteBulkOperations}>
                  <RemoveCircleIcon sx={{ color: 'gray' }} />
                </IconButton>
              </Box>
              <Box>
                <TableContainer component={Paper} sx={{ boxShadow: 'unset', pr: '6px' }}>
                  <Table sx={{}} aria-label="spanning table">
                    <TableHead
                      sx={{
                        '.MuiTableCell-root': {
                          padding: '5px 16px',
                          borderBottom: 'unset',
                          fontWeight: 800,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell align="center" colSpan={2}>
                          {t('monPatrimoine.dateColumn')}
                        </TableCell>
                        <TableCell sx={{ padding: '5px !important' }} align="right">
                          {t('monPatrimoine.tauxColumn')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{ '.MuiTableCell-root': { padding: '0px', borderBottom: 'unset' } }}
                    >
                      {taxrates.map((el) => (
                        <TableRow key={el.id}>
                          <TableCell colSpan={2}>
                            <FormControlLabel
                              className="ficheck"
                              control={
                                <Checkbox
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelected([...selected, el.id])
                                    } else {
                                      setSelected([...selected.filter((c) => c !== el.id)])
                                    }
                                  }}
                                />
                              }
                              label={convertToUserDateFormate(siteUser.user, el.Date)}
                            />
                          </TableCell>

                          <TableCell align="right">{parseInt(el.Taux).toFixed(0)}%</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box width={'100%'}>
              <Line options={options} data={data} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button type="submit">Valider</Button> */}
          <Button onClick={handleClose}>{t('monPatrimoine.cancel')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

function AddTaux({ updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)

  const { handleSubmit, reset, control } = useForm({})

  useEffect(() => {}, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    updateReports()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePostRequest(urls.TaxRateOperations, payload, {}, true)
    if (response.status === 201) {
      setOpen(false)
      handleClose()
    }
  }

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <AddCircleIcon sx={{ color: 'gray' }} />
      </IconButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose} className="no-drag">
        <DialogTitle sx={{ color: '#383838 !important' }}>{t('monPatrimoine.updateTaxDialogTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'date',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="Date"
              label={t('monPatrimoine.dateColumn')}
            />{' '}
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: true }}
              name="Taux"
              label={t('monPatrimoine.tauxColumn')}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('monPatrimoine.validate')}</Button>
            <Button onClick={handleClose}>{t('monPatrimoine.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
